import React from "react";
import { MathOperatorButtonType } from "../mathOperatorTypes";

const Button = ({ className, value, onClick }: MathOperatorButtonType) => {
  
  let buttonClass = className === "bigButton" ?
    'tw-text-center tw-text-slate-900 tw-text-lg tw-font-semibold tw-font-["Noto Sans"] tw-leading-relaxed tw-border-solid tw-col-span-2 tw-w-[100%] tw-h-11 tw-border-[1px] tw-rounded-sm tw-p-2 tw-gap-2 tw-text-black tw-font-bold tw-cursor-pointer hover:tw-bg-[#D1D1D6] tw-bg-white':
    'tw-text-center tw-text-slate-900 tw-text-lg tw-font-semibold tw-font-["Noto Sans"] tw-leading-relaxed tw-border-solid tw-w-[100%] tw-h-11 tw-rounded-sm tw-border-[1px] tw-p-2 tw-gap-2 tw-text-black tw-font-bold tw-cursor-pointer hover:tw-bg-[#D1D1D6] tw-bg-white'
  return (
    <button className={buttonClass} onClick={onClick}
      >
      {value}
    </button>
  );
};

export default Button;